export const calculateDirectionBasedonScreenPosition = (
  tooltipParentElement?: HTMLElement | null,
  tooltipElement?: HTMLElement | null,
  tooltipDirection?: string
): string => {
  let newPosition = '';

  if (tooltipParentElement && tooltipElement) {
    const targetRect = tooltipParentElement.getBoundingClientRect();
    const tooltipRect = tooltipElement.getBoundingClientRect();

    const viewportHeight = window.innerHeight;

    if (tooltipDirection === 'bottom' && targetRect.bottom + tooltipRect.height > viewportHeight) {
      newPosition = 'top';
    } else if (tooltipDirection === 'top' && targetRect.top - tooltipRect.height < 0) {
      newPosition = 'bottom';
    }
  }

  return newPosition;
};
